import http from "@/services/http";
import { systemMessageResponse } from "@/services/unauthService/types";

export async function getSystemDowntime() {
  const { data } = await http().get(
    globalThis.env.API_UNAUTH + "/system-messages/COMMERCE_SYSTEM_DOWN_MESSAGE"
  );
  return systemMessageResponse.parse(data);
}

export async function getAnnouncementBanner() {
  const { data } = await http().get(
    globalThis.env.API_UNAUTH + "/system-messages/CISCOU_ANNOUNCEMENT_BANNER"
  );
  return systemMessageResponse.parse(data);
}
